import { CSSObject } from '@chakra-ui/react';
import { BottomRowSchema } from '@/views/account/MyBets/Components/MyBetsCard/components/BottomRow/styles/BottomRow.styles';

export const bottomRowStyles: BottomRowSchema = {
  flexWrapper: {},
  buttonCashOutDesc: { borderRadius: 'lg', paddingBottom: 0.5 },
  buttonCashOutAmount: { borderRadius: 'lg', paddingBottom: 0.5 },
  flexOddsBoostBanner: {
    fontWeight: 'bold',
    color: 'alpha.800',
    border: 'none',
    borderRadius: 'md',
    bgGradient: 'linear(to-b, alpha.400, alpha.600)',
  },
  iconOddsBoost: {
    fill: 'alpha.800',
  },
  textOddsBoost: {
    color: 'alpha.800',
  },
  iconCashOut: {
    fill: 'alpha.700',
    boxSize: 7,
    mb: '0.5',
  },
  cashoutValue: {
    color: 'alpha.700',
  },
};

export const LinkVenueName: CSSObject = {
  color: 'beta.500',
};

export const RaceTime: CSSObject = {
  color: 'gray.400',
  fontWeight: 'medium',
};

export const BonusBetCheckMark: CSSObject = {
  bg: 'alpha.500',
  color: 'white',
  fontSize: 'sm',
};

export const BonusBetText: CSSObject = {
  color: 'alpha.500',
  fontSize: 'sm',
  fontWeight: 'normal',
  fontFamily: 'Roboto',
};

export const BetReturn: CSSObject = {
  borderRadius: 'base',
  fontWeight: 'medium',
  fontSize: '2xs',
  borderWidth: '1px',
  borderColor: 'alpha.500',
  overflow: 'hidden',
};

export const BoxBetReturnValue: CSSObject = {
  bgGradient: 'linear(180deg, alpha.400, alpha.500)',
  py: '0.5',
  p: '1',
  fontWeight: 'bold',
  color: 'alpha.900',
};

export const BoxBetReturnText: CSSObject = {
  p: '1',
  color: 'alpha.900',
  bg: '#fff',
};
